document.addEventListener("DOMContentLoaded", function () {
  const zoomDialog = document.querySelector("product-image-zoom");
  if (!zoomDialog) return;

  const zoomId = zoomDialog.id;

  // Find the EXISTING zoom trigger (lens icon)
  const zoomTrigger = document.querySelector(
    `[aria-controls="${zoomId}"]`
  );

  if (!zoomTrigger) {
    console.warn("Focal zoom trigger not found");
    return;
  }

  // Make product images clickable
  const images = document.querySelectorAll(
    ".product__media img, .product__media-item img"
  );

  images.forEach((img) => {
    img.style.cursor = "zoom-in";

    img.addEventListener("click", function () {
      zoomTrigger.click(); // ✅ THIS is the magic
    });
  });
});
